import type {GroupField, ImageField, KeyTextField, RichTextField, SelectField} from '@prismicio/client'
import {PrismicNextImage} from '@prismicio/next/pages'
import {PrismicRichText} from '@prismicio/react'
import type {PricingSectionSliceLargePrimaryFirstPackagePillsItem, Simplify} from 'prismicio-types'
import * as icons from 'slices/PricingSection/components/Icons'
import {PricingPill} from './PricingPill'

export const MossPlatformLargeSection = ({
  title,
  pills = [],
  icon,
  moduleTitle,
  description,
  asset,
}: {
  title: KeyTextField
  pills: GroupField<Simplify<PricingSectionSliceLargePrimaryFirstPackagePillsItem>>
  icon: SelectField<'MossLogo' | 'Cards'> | undefined
  moduleTitle: KeyTextField
  description: RichTextField
  asset: ImageField
}) => {
  const Icon = icons[icon as keyof typeof icons]

  return (
    <div className="flex flex-col gap-6 md:max-lg:overflow-hidden">
      <div className="flex flex-col gap-3 lg:flex-row lg:items-center lg:gap-8">
        <h4 className="text-[24px] font-medium leading-[normal] text-moss-black">{title}</h4>
        {pills.length > 0 && (
          <div className="flex flex-wrap items-center gap-2 lg:gap-3">
            {pills.map((pill, index) => (
              <PricingPill pill={pill} key={`pill-${index}`} />
            ))}
          </div>
        )}
      </div>
      <div className="relative flex justify-between rounded-lg bg-green-neon max-md:flex-col md:max-lg:max-h-[260px] md:max-lg:min-h-[200px] md:max-lg:gap-10 lg:h-[280px]">
        <div className="flex size-full flex-col justify-between gap-4 px-6 pt-6 md:py-6 md:pl-6 md:pr-0">
          <div className="flex items-center gap-4">
            <div className="relative flex size-10 items-center justify-center rounded-md bg-green-dark">
              <Icon style={{width: '25px', height: '21px'}} />
            </div>
            <h5 className="text-18 font-medium leading-[30px] text-moss-black">{moduleTitle}</h5>
          </div>
          <PrismicRichText
            field={description}
            components={{
              paragraph: ({children}) => <p className="text-tg-body-m max-w-[319px] text-moss-black">{children}</p>,
            }}
          />
        </div>
        <PrismicNextImage
          field={asset}
          quality={100}
          className="w-full px-6 pt-6 md:h-full md:w-auto md:max-lg:h-min md:max-lg:w-1/2 md:max-lg:self-end"
        />
        <div className="pointer-events-none absolute inset-0 rounded-lg border border-[rgba(19,19,19,.1)]" />
      </div>
    </div>
  )
}
